/**
 * The businesses the signed-in person may work in.
 *
 * Always about the caller — there is no id to pass and no way to ask about
 * anybody else, which is the same rule `/merchants/me` follows and for the same
 * reason.
 */

import { api } from "@/api/client";

export interface Membership {
  id: string;
  name: string;
  merchant_number: string;
  /** Their own business: the one they land in, and the one that cannot be revoked. */
  is_home: boolean;
  /** Role codes held in *this* business. Roles do not travel between them. */
  roles: string[];
}

export const membershipRepository = {
  mine: () => api.get<Membership[]>("/auth/memberships/"),
};
